const fmt = (v) => {
    if (v === null || v === undefined || v === '') return '—';
    return typeof v === 'number' ? v.toLocaleString('en-GH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : v;
};

const pct = (v) => {
    if (v === null || v === undefined || v === 0) return '—';
    return `${(v * 100).toFixed(1)}%`;
};

const inputClass = "w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:ring-1 focus:ring-[#1e3a6e] focus:border-[#1e3a6e] disabled:bg-gray-50";

function MasterInputSection({ masterInput, onChange, readOnly }) {
    const mi = masterInput || {};

    const handleChange = (field, value) => {
        if (onChange) onChange('masterInput', field, value);
    };

    const ltp = mi.vestedCollateral > 0 ? mi.requestedLoanAmount / mi.vestedCollateral : 0;
    const monthlyRate = mi.annualInterestRate > 0 ? mi.annualInterestRate / 100 / 12 : 0;
    const indicativeRepayment = mi.requestedTenure > 0 && mi.requestedLoanAmount > 0
        ? (mi.requestedLoanAmount / mi.requestedTenure) + (mi.requestedLoanAmount * monthlyRate)
        : 0;

    return (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-y border-gray-200 rounded-t-lg">
                <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">01 — Master Input</h3>
                <span className="text-xs text-gray-400">Pre-populated from loan application</span>
            </div>

            {/* Section A — Customer Information */}
            <div className="px-4 pt-3 pb-1">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Section A — Customer Information</span>
            </div>
            <div className="grid grid-cols-2 gap-3 px-4 py-3">
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Customer Name</label>
                    <input type="text" value={mi.customerName || ''} disabled={readOnly}
                        onChange={e => handleChange('customerName', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Ghana Card Number</label>
                    <input type="text" value={mi.ghanaCardNumber || ''} disabled={readOnly}
                        onChange={e => handleChange('ghanaCardNumber', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Phone Number</label>
                    <input type="text" value={mi.phoneNumber || ''} disabled={readOnly}
                        onChange={e => handleChange('phoneNumber', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Date of Birth</label>
                    <input type="date" value={mi.dateOfBirth ? new Date(mi.dateOfBirth).toISOString().split('T')[0] : ''} disabled={readOnly}
                        onChange={e => handleChange('dateOfBirth', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">GPS Address</label>
                    <input type="text" value={mi.gpsAddress || ''} disabled={readOnly}
                        onChange={e => handleChange('gpsAddress', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Residential Region</label>
                    <input type="text" value={mi.residentialRegion || ''} disabled={readOnly}
                        onChange={e => handleChange('residentialRegion', e.target.value)}
                        className={inputClass} />
                </div>
                <div className="col-span-2">
                    <label className="block text-xs font-medium text-gray-500 mb-1">Email</label>
                    <input type="email" value={mi.email || ''} disabled={readOnly}
                        onChange={e => handleChange('email', e.target.value)}
                        className={inputClass} />
                </div>
            </div>

            {/* Section B — Employment Information */}
            <div className="px-4 pt-3 pb-1 border-t border-gray-100">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Section B — Employment Information</span>
            </div>
            <div className="grid grid-cols-2 gap-3 px-4 py-3">
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Employer Name</label>
                    <input type="text" value={mi.employerName || ''} disabled={readOnly}
                        onChange={e => handleChange('employerName', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Employment Status</label>
                    <input type="text" value={mi.employmentStatus || ''} disabled={readOnly}
                        onChange={e => handleChange('employmentStatus', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Job Title</label>
                    <input type="text" value={mi.jobTitle || ''} disabled={readOnly}
                        onChange={e => handleChange('jobTitle', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Start Date of Employment</label>
                    <input type="date" value={mi.startDateOfEmployment ? new Date(mi.startDateOfEmployment).toISOString().split('T')[0] : ''} disabled={readOnly}
                        onChange={e => handleChange('startDateOfEmployment', e.target.value)}
                        className={`${inputClass} ${!mi.startDateOfEmployment ? 'bg-yellow-50 border-yellow-300' : ''}`}
                        placeholder="Staff to fill" />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Net Monthly Salary (GHS)</label>
                    <input type="number" value={mi.netMonthlySalary || ''} disabled={readOnly}
                        onChange={e => handleChange('netMonthlySalary', parseFloat(e.target.value) || 0)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Salary Payment Frequency</label>
                    <input type="text" value={mi.salaryPaymentFrequency || ''} disabled={readOnly}
                        onChange={e => handleChange('salaryPaymentFrequency', e.target.value)}
                        className={inputClass} />
                </div>
            </div>

            {/* Section C — Pension Information */}
            <div className="px-4 pt-3 pb-1 border-t border-gray-100">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Section C — Pension Information</span>
            </div>
            <div className="grid grid-cols-2 gap-3 px-4 py-3">
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Pension Trustee</label>
                    <input type="text" value={mi.pensionTrustee || ''} disabled={readOnly}
                        onChange={e => handleChange('pensionTrustee', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Pension ID</label>
                    <input type="text" value={mi.pensionId || ''} disabled={readOnly}
                        onChange={e => handleChange('pensionId', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Total Tier 3 Balance (GHS)</label>
                    <input type="number" value={mi.totalTier3Balance || ''} disabled={readOnly}
                        onChange={e => handleChange('totalTier3Balance', parseFloat(e.target.value) || 0)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Vested Amount as Collateral (GHS)</label>
                    <input type="number" value={mi.vestedCollateral || ''} disabled={readOnly}
                        onChange={e => handleChange('vestedCollateral', parseFloat(e.target.value) || 0)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Avg Monthly Contribution (GHS)</label>
                    <input type="number" value={mi.avgMonthlyContribution || ''} disabled={readOnly}
                        onChange={e => handleChange('avgMonthlyContribution', parseFloat(e.target.value) || 0)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Contribution History (Years)</label>
                    <input type="number" value={mi.contributionHistoryYears || ''} disabled={readOnly}
                        onChange={e => handleChange('contributionHistoryYears', parseFloat(e.target.value) || 0)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Contributions in Last 12 Months</label>
                    <input type="number" value={mi.contributionsLast12Months || ''} disabled={readOnly}
                        onChange={e => handleChange('contributionsLast12Months', parseInt(e.target.value) || 0)}
                        className={inputClass} />
                </div>
            </div>

            {/* Section D — Loan Request */}
            <div className="px-4 pt-3 pb-1 border-t border-gray-100">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Section D — Loan Request</span>
            </div>
            <div className="grid grid-cols-2 gap-3 px-4 py-3">
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Requested Loan Amount (GHS)</label>
                    <input type="number" value={mi.requestedLoanAmount || ''} disabled={readOnly}
                        onChange={e => handleChange('requestedLoanAmount', parseFloat(e.target.value) || 0)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Requested Tenure (months)</label>
                    <input type="number" value={mi.requestedTenure || ''} disabled={readOnly}
                        onChange={e => handleChange('requestedTenure', parseInt(e.target.value) || 0)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Repayment Frequency</label>
                    <input type="text" value={mi.repaymentFrequency || ''} disabled={readOnly}
                        onChange={e => handleChange('repaymentFrequency', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Loan Purpose</label>
                    <input type="text" value={mi.loanPurpose || ''} disabled={readOnly}
                        onChange={e => handleChange('loanPurpose', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Annual Interest Rate</label>
                    <input type="number" step="0.01" value={mi.annualInterestRate || ''} disabled={readOnly}
                        onChange={e => handleChange('annualInterestRate', parseFloat(e.target.value) || 0)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Existing Loans (GHS)</label>
                    <input type="number" value={mi.existingLoans || ''} disabled={readOnly}
                        onChange={e => handleChange('existingLoans', parseFloat(e.target.value) || 0)}
                        className={inputClass} />
                </div>
            </div>

            {/* Section E — Bank & MoMo Reference */}
            <div className="px-4 pt-3 pb-1 border-t border-gray-100">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Section E — Bank & MoMo Reference</span>
            </div>
            <div className="grid grid-cols-2 gap-3 px-4 py-3">
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Primary Bank Name</label>
                    <input type="text" value={mi.primaryBankName || ''} disabled={readOnly}
                        onChange={e => handleChange('primaryBankName', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Account Number</label>
                    <input type="text" value={mi.accountNumber || ''} disabled={readOnly}
                        onChange={e => handleChange('accountNumber', e.target.value)}
                        className={inputClass} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-500 mb-1">Mobile Money Number</label>
                    <input type="text" value={mi.mobileMoneyNumber || ''} disabled={readOnly}
                        onChange={e => handleChange('mobileMoneyNumber', e.target.value)}
                        className={inputClass} />
                </div>
            </div>

            {/* Section F — Auto-Calculated Summary */}
            <div className="px-4 pt-3 pb-1 border-t border-gray-100">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Section F — Auto-Calculated Summary</span>
            </div>
            <div className="grid grid-cols-3 gap-3 px-4 py-3 pb-4">
                <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-xs text-gray-500 mb-1">Loan-to-Pension Ratio (LTP)</p>
                    <p className={`text-lg font-bold ${ltp <= 0.8 ? 'text-green-700' : 'text-red-600'}`}>
                        {pct(ltp)}
                    </p>
                    <p className="text-xs text-gray-400">Threshold ≤ 80%</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-xs text-gray-500 mb-1">Tenure with Employer</p>
                    <p className="text-lg font-bold text-gray-800">
                        {mi.startDateOfEmployment
                            ? `${Math.floor((new Date() - new Date(mi.startDateOfEmployment)) / (1000 * 60 * 60 * 24 * 30))} months`
                            : '—'}
                    </p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-xs text-gray-500 mb-1">Indicative Monthly Repayment</p>
                    <p className="text-lg font-bold text-gray-800">GHS {fmt(Math.round(indicativeRepayment * 100) / 100)}</p>
                    <p className="text-xs text-gray-400">Flat (add-on) method</p>
                </div>
            </div>
        </div>
    );
}

export default MasterInputSection;
